<template>
  <app-view>
    <div class="content">{{value.content}}</div>
    <div class="version">v1.0.1</div>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import HtmlContent from '../components/HtmlContent.vue'

  export default {
    components: {AppView, HtmlContent},
    data () {
      return {
        value: {}
      }
    },
    async mounted () {
      this.value = await this.$service.other.loadAbout()
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    padding: $app-padding;
    background-color: $color-white;
    .content {
      white-space: pre-wrap;
    }
    .version {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
      font-size: 10px;
      color: $thirdly-text-color;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?9a882f44